import React, { useState, useEffect, useCallback } from "react";
import {
  Grid,
  Card,
  Button,
  Modal,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  // Switch,
  // Dialog,
  // DialogTitle,
  // DialogContent,
  // DialogContentText,
  // DialogActions,
  Backdrop,
  CircularProgress,
  Alert,
  Snackbar,
  Autocomplete
} from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import apiRequest from "../../apiRequest";
import { endPoints } from "../../apis";

function NotificationManagement() {
  const [notification, setNotifications] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [accessToken, setAccessToken] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [topics, setTopics] = useState([]);

  const [notiData, setNotiData] = useState({
    title: "",
    message: "",
    send_to: "",
    is_scheduled: false,
    schedule_at: null,
   
  });

  const initialState = {
    title: "",
    message: "",
    send_to: "",
    is_scheduled: false,
    schedule_at: null,
  };

  const getNotification = useCallback(
    async (page) => {
      setLoading(true);
      try {
        const params = { page, total: totalItems };
        const headers = {
        //   "x-access-token": accessToken,
        };
        const response = await apiRequest.get(endPoints.GET_NOTIFICATIONS,
          params,
          headers,
        );

        if (response.success) {
          const { items, pagination } = response.data;
          setNotifications(items);
          setTotalPages(pagination.total_pages);
          setCurrentPage(pagination.current_page);
          setTotalItems(pagination.totalItems);
        }
      } catch (error) {
        console.error("Error fetching notification:", error);
        setError("Failed to fetch notification. Please try again.");
      } finally {
        setLoading(false);
      }
    },
    [ totalItems]
  );

const fetchTopics = useCallback( async () => {
    try {
      const params = { limit: 0 };
      const headers = {
        "x-access-token": accessToken,
      };
      const response = await apiRequest.get(endPoints.GET_TOPICS,
        params,
        headers,
      );

      if (response.success) {
      
        setTopics(response.data);
      }
    } catch (error) {
      console.error("Error fetching sliders:", error);
    } finally {
    }
  }, [accessToken]);

  // Fetch category when currentPage changes
  useEffect(() => {
    setAccessToken(localStorage.getItem("access_token"));
    getNotification(currentPage);
    fetchTopics();
  }, [currentPage, getNotification, fetchTopics]);

  // Handle modal open/close
  const handleOpenModal = () => {
    setOpenModal(true);
    setNotiData(initialState);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
    setNotiData(initialState);
  };

  // Handle form input change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNotiData({ ...notiData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(null);    

    try {
     
      const data = {
        title: notiData.title,
        message: notiData.message,
        send_to: notiData.send_to,
      }
      // Send the request
      const response = await apiRequest.post(endPoints.ADD_NOTIFICATION, data, {
        headers: {
        //   'Content-Type': 'multipart/form-data',
          'x-access-token': accessToken,
        },
      });

      // Handle the response
      if (response.success) {
        setSuccess( "Notification added successfully.");
        getNotification(currentPage); 
        handleCloseModal(); // Close the modal
      } else {
        setError(response.message || 'Failed to add.');
      }
    } catch (error) {
      console.error('Error:', error);
      setError('An error occurred while processing your request.');
    } finally {
      setLoading(false);
    }
  };

  // Handle edit servict type
  const handleTryAgain = async (noti) => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
     
      const data = {
        id: noti.id,
      }
     
      // Send the request
      const response = await apiRequest.post(endPoints.TRY_NOTIFICATION, data, {
        headers: {
        //   'Content-Type': 'multipart/form-data',
          'x-access-token': accessToken,
        },
      });

      // Handle the response
      if (response.success) {
        setSuccess( "Notification send successfully.");
        getNotification(currentPage); 
      } else {
        setError(response.message || 'Failed to add.');
      }
    } catch (error) {
      console.error('Error:', error);
      setError('An error occurred while processing your request.');
    } finally {
      setLoading(false);
    }

  };



  // Handle page change
  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage); // Update the current page
    }
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Notification Management
                </MDTypography>
              </MDBox>
              <MDBox pt={1} px={1}>
                <MDBox
                  pt={1}
                  px={1}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                  gap={2}
                >
                  <TextField
                    label="Search"
                    variant="outlined"
                    margin="normal"
                    placeholder="Search by title or description"
                    style={{ width: "300px" }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenModal}
                    style={{
                      whiteSpace: "nowrap",
                      color: "white",
                    }}
                  >
                    Create Notification
                  </Button>
                </MDBox>
                <TableContainer component={Paper} style={{ marginTop: "1px" }}>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell style={{ fontWeight: "bold" }}>Title</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>Description</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>Sent To</TableCell>
                        {/* <TableCell style={{ fontWeight: "bold" }}>Photo</TableCell> */}
                        <TableCell style={{ fontWeight: "bold" }}>Delivered</TableCell>
                      </TableRow>
                      {notification.map((noti) => (
                        <TableRow key={noti.id}>
                          <TableCell>{noti.title}</TableCell>
                          <TableCell>{noti.message}</TableCell>
                          <TableCell>{noti.send_to}</TableCell>
                        
                          <TableCell>
                            {noti.delivered ? (
                              `Yes (${new Date(noti.delivered_at).toLocaleString()})`
                            ) : (
                              <Button
                                color="primary"
                                size="small"
                                onClick={() => handleTryAgain(noti)}
                              >
                                Try Again
                              </Button>
                            )}
                          </TableCell>

                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* Pagination Controls */}
                <MDBox mt={2} display="flex" justifyContent="center" alignItems="center">
                  <Button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </Button>
                  <MDTypography mx={2}>
                    Page {currentPage} of {totalPages} {/* Display current page and total pages */}
                  </MDTypography>
                  <Button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </Button>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      {/* Modal for Adding/Editing Service Type */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <MDBox
          p={3}
          bgcolor="white"
          borderRadius="lg"
          style={{
            width: 900,
            margin: "50px auto",
            outline: "none",
            backgroundColor: "white",
            maxHeight: "80vh", // Limit the height of the modal
            overflowY: "auto", // Enable vertical scrolling
          }}
        >
          <MDTypography variant="h6" mb={2}>
            Create Notification
          </MDTypography>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                <Autocomplete
                  options={topics}
                  getOptionLabel={(option) => option?.name || ""} // Show "name" in UI
                  value={topics.find(topic => topic.topic === notiData.send_to) || null} // Match using "topic"
                  onChange={(event, newValue) => {
                    setNotiData({ ...notiData, send_to: newValue ? newValue.topic : null }); // Store "topic"
                  }}
                  renderInput={(params) => <TextField {...params} label="Select Topic" required />}
                />

                </Grid>

              {/* Title (EN) */}
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  label="Title "
                  name="title"
                  value={notiData.title}
                  onChange={handleInputChange}
                  margin="normal"
                  required
                />
              </Grid>

              {/* Description (EN) */}
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  label="Message"
                  name="message"
                  value={notiData.message}
                  onChange={handleInputChange}
                  margin="normal"
                  multiline
                  rows={3}
                  required
                />
              </Grid>

            </Grid>

            <MDBox mt={3} display="flex" justifyContent="flex-end">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                style={{
                  whiteSpace: "nowrap",
                  color: "white",
                }}
              >
                Add
              </Button>
            </MDBox>
          </form>
        </MDBox>
      </Modal>

     

      {/* Loading Backdrop */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Error/Success Snackbar */}
      <Snackbar
        open={!!error || !!success}
        autoHideDuration={3000}
        onClose={() => {
          setError(null);
          setSuccess(null);
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // Positioning the Snackbar
      >
        <Alert
          onClose={() => {
            setError(null);
            setSuccess(null);
          }}
          severity={error ? "error" : "success"}
          sx={{ width: '100%' }}
        >
          {error || success}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
}

export default NotificationManagement;